import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LandingPageComponent } from './components/welcome/landing-page/landing-page.component';
import { WelcomeComponent } from './components/welcome/welcome/welcome.component';
import { ForgotPasswordComponent } from './components/security/forgot-password/forgot-password.component';
import { MenuComponent } from './components/security/menu/menu.component';
import { LargePopupComponent } from './pop-ups/large-popup/large-popup.component';
import { MediumPopupComponent } from './pop-ups/medium-popup/medium-popup.component';
import { SmallPopupComponent } from './pop-ups/small-popup/small-popup.component';

import { ToastrModule } from 'ngx-toastr';
import { JwtModule } from '@auth0/angular-jwt';
import { AppConfig } from './app.config';
import { NgxPaginationModule } from 'ngx-pagination';

import { AgGridModule } from 'ag-grid-angular';
import 'ag-grid-enterprise';

import { HighchartsChartModule } from 'highcharts-angular';


import { AuthGuard } from './auth-guard';
import { FilterPipe } from './pipes/generic-filter.pipe';
import { SharedModule } from './modules/shared.module';


export function tokenGetter() {
  return localStorage.getItem('access_token');
}

@NgModule({
  declarations: [
    AppComponent,
  
    LandingPageComponent,
    WelcomeComponent,
    ForgotPasswordComponent,
    MenuComponent,
    LargePopupComponent,
    MediumPopupComponent,
    SmallPopupComponent,





   
  
 
  ],
  // imports: [
  //   BrowserModule,
  //   FormsModule,
  //   AppRoutingModule
  // ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    HttpClientModule,

    SharedModule,

    HighchartsChartModule,

    ReactiveFormsModule,
    NgxPaginationModule,
    AgGridModule.withComponents([]),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        // whitelistedDomains: ["example.com"],
        // blacklistedRoutes: ["example.com/examplebadroute/"]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 7000,
      positionClass: 'toast-top-right',
    }),
  ],
  providers: [
    AppConfig,
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
